import request from '@/utils/request'

export function logout() {
    return request({
        url: '/Fard/Logout',
        method: 'post'
    })
}

export function getUserInfo() {
    return request({
        url: '/Fard/GetCurrentUserInfo',
        method: 'post'

    })
}

export function FindUserByCode(pattern) {
    return request({
        url: '/Fard/FindUserByCode',
        method: 'post',
        data: { Pattern: pattern }
    })
}